import React from "react";
import {getInitialQuestions} from "./questions";

export function ApplicationPreview() {
    const questions = getInitialQuestions("HTD");
    const resumeQuestion = questions.find((q) => q.id === "resume");
    return (
        <>
            <div className="application-form max-w-3xl mx-auto mt-6">
                <h2 className="px-6 py-3 application-form-border text-left">Quick Apply</h2>
                <div className="space-y-1">
                    <div className="p-6  space-y-2">
                        {questions.map((q) => {
                            let questionType = q.type;
                            switch (questionType) {
                                case "label":
                                    return (
                                        <section key={q.id} className="w-full mt-8">
                                            <div className="text-sm font-medium font-semibold ml-3">
                                                {q.label}
                                                {q.required && "*"}
                                            </div>
                                            <div className="application-question-input-border peer w-full border rounded px-2 py-2 bg-white placeholder-transparent focus:outline-none focus:ring-0 text-gray-700">
                                                {q.answer as string}
                                            </div>
                                        </section>
                                    );
                                case "text":
                                    return (
                                        <section key={q.id} className="w-full mt-8">
                                            <div key={q.id} className="block relative">
                                                <input
                                                    id={q.id}
                                                    value={(q.answer as string) ?? ""}
                                                    placeholder=" " /* required for peer-placeholder-shown */
                                                    className="application-question-input-border peer w-full border rounded px-2 py-2 bg-white placeholder-transparent focus:outline-none focus:ring-0"
                                                    aria-required={q.required}
                                                    aria-label={q.label}
                                                    disabled={true}
                                                />

                                                <span
                                                    className={
                                                        "absolute left-3 top-3 text-sm font-semibold pointer-events-none transition-all duration-200 transform origin-left " +
                                                        "peer-placeholder-shown:translate-y-0 " +
                                                        "peer-focus:-translate-y-8"
                                                    }
                                                >
                                                    {q.label}
                                                    {q.required && "*"}
                                                </span>
                                            </div>
                                        </section>
                                    );
                                case "dropdown":
                                    return (
                                        <div key={q.id} className="mt-6 space-y-1 text-left w-full">
                                            <div className="text-sm font-medium font-semibold ml-3">
                                                {q.label}
                                                {q.required && "*"}
                                            </div>
                                            {/* <DropDown
                                                items={localOptions.map((opt) => ({
                                                    label: opt.label,
                                                    value: opt.value,
                                                }))}
                                                label={`Select ${q.label}`}
                                                selectedValue={q.answer as string}
                                                onSelect={(value) => {
                                                    if (value !== "") updateAnswer(q.id, value);
                                                }}
                                            />  */}
                                        </div>
                                    );
                                case "select":
                                    return (
                                        <section style={{marginTop: "1.8rem"}} key={q.id}>
                                            <div className="space-y-2 text-left">
                                                <div className="flex text-sm font-medium font-semibold uppercase text-600">
                                                    <span>
                                                        {q.label}
                                                        {q.required && "*"}
                                                    </span>
                                                </div>
                                                <div className="flex flex-wrap gap-2">
                                                    {q.options?.map((opt) => {
                                                        const isSelected = q.answer != null && q.answer === opt.value;
                                                        const isCodingAbility = q.id === "codingAbility";
                                                        return (
                                                            <div
                                                                className={`${isCodingAbility ? "application-code-rating-btn" : ""}`}
                                                            >
                                                                <button
                                                                    key={opt.label}
                                                                    className="application-question-select-btn p-2"
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: isSelected
                                                                            ? "var(--secondary)"
                                                                            : "transparent",
                                                                        color: isSelected ? "white" : "var(--font)",
                                                                    }}
                                                                >
                                                                    {q.id === "workAuthorization" ? (
                                                                        opt.label === "No" ? (
                                                                            <span className="font-bold">
                                                                                {opt.label}
                                                                            </span>
                                                                        ) : (
                                                                            <>
                                                                                <span className="font-bold">
                                                                                    Yes -{" "}
                                                                                </span>
                                                                                {opt.label}
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        opt.label
                                                                    )}
                                                                </button>
                                                                {isCodingAbility && opt.value === "0" && (
                                                                    <span className="text-xs font-semibold">
                                                                        Lowest
                                                                    </span>
                                                                )}
                                                                {isCodingAbility && opt.value === "10" && (
                                                                    <span className="text-xs font-semibold">
                                                                        Highest
                                                                    </span>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </section>
                                    );
                                default:
                                    return null;
                            }
                        })}
                    </div>
                    {resumeQuestion && (
                        <section className="p-6 space-y-2">
                            <div className="text-left text-2xl font-semibold">
                                {resumeQuestion.label} {resumeQuestion.required && "*"}
                            </div>
                            <label className="block border-2 border-dashed border-[var(--font)] rounded-sm p-6 text-center cursor-pointer">
                                <input type="file" accept=".pdf,.doc,.docx" className="hidden" />
                                <div className="font-semibold">Choose a file</div>
                                <div className="font-bold">or click to browse</div>
                                <div>Resume File Types: .pdf .doc .docx</div>
                            </label>
                        </section>
                    )}
                    <section key="privacy-policy" className="px-6 py-2 space-y-2">
                        <div className="text-left text-xs">
                            By providing a telephone number and submitting the form you are consenting to be contacted
                            by SMS text message. Message and data rates may apply. Reply STOP to opt out of further
                            messaging.{" "}
                            <span className="application-privacy-link">
                                This is the link to our company privacy policy.
                            </span>
                        </div>
                    </section>

                    <div className="p-6 text-center">
                        <button type="submit" className="action-btn">
                            APPLY NOW
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
